import { useMutation, useQuery } from 'react-query';
import {
  CRUD_GET_ONE,
  useGetOne,
  useGetResourceLabel,
  useResourceContext,
  useTranslate,
  useVersion,
} from 'react-admin';
import {
  approvePendingApproval,
  cancelPendingApproval,
  claimPendingApproval,
  getApprovalCaseActions,
  getApprovalCaseFromHistory,
  getApprovalCaseFromQueue,
  getApprovalCaseUnified,
  rejectPendingApproval,
  unclaimPendingApproval,
} from '~/api/approvals';

const approvalActionsKey = (id: string) => ['approvalActions', id];

export const useApprovalCaseActions = (id: string, options?: { enabled?: boolean }) => {
  return useQuery(approvalActionsKey(id), () => getApprovalCaseActions(id), {
    enabled: !!id && options?.enabled,
    onError: () => {},
  });
};

export const useClaimApprovalMutation = () => {
  return useMutation(claimPendingApproval);
};

export const useUnclaimApprovalMutation = () => {
  return useMutation(unclaimPendingApproval);
};

export const useApproveApprovalMutation = () => {
  return useMutation(approvePendingApproval);
};

export const useRejectApprovalMutation = () => {
  return useMutation(rejectPendingApproval);
};

export const useCancelApprovalMutation = () => {
  return useMutation(cancelPendingApproval);
};

export const useGetApprovalCaseFromQueue = () => {
  return useMutation(getApprovalCaseFromQueue, {
    onError: () => {},
  });
};

export const useGetApprovalCaseFromHistory = () => {
  return useMutation(getApprovalCaseFromHistory, {
    onError: () => {},
  });
};

export const useGetApprovalCase = (approvalCaseId: string | undefined, enabled: boolean) => {
  return useQuery(
    ['approvalCaseDetail', approvalCaseId],
    () => getApprovalCaseUnified(approvalCaseId!),
    {
      enabled: !!approvalCaseId && enabled,
      onError: () => {},
    }
  );
};

export const useApprovalShowController = (props: any) => {
  const { basePath, hasCreate, hasEdit, hasList, hasShow, id } = props;
  const resource = useResourceContext(props);
  const translate = useTranslate();
  const version = useVersion();
  const getResourceLabel = useGetResourceLabel();

  const { data: record, loading, loaded, error } = useGetOne(resource, id, {
    action: CRUD_GET_ONE,
    onFailure: () => {},
  });

  const defaultTitle = translate('ra.page.show', {
    name: getResourceLabel(resource, 1),
    id,
    record,
  });

  return {
    loading,
    loaded,
    error,
    defaultTitle,
    resource,
    basePath,
    record,
    hasCreate,
    hasEdit,
    hasList,
    hasShow,
    version,
  };
};
